import React from 'react';

export const name = 'profile';

export const Profile = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99951 15.84V10.3387H14.0008V15.84"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M11.9982 4.87313C11.9982 5.46634 11.8222 6.04622 11.4925 6.53938C11.1628 7.03254 10.6943 7.41682 10.1461 7.64357C9.59795 7.87032 8.99483 7.92937 8.4131 7.81323C7.83137 7.69709 7.29717 7.41099 6.8781 6.99113C6.45902 6.57127 6.17393 6.03653 6.05888 5.45458C5.94383 4.87263 6.00401 4.26963 6.23179 3.72189C6.45957 3.17416 6.84473 2.7063 7.33851 2.37754C7.83228 2.04878 8.41249 1.87389 9.0057 1.87501C9.79988 1.8765 10.561 2.19303 11.1221 2.75512C11.6831 3.31722 11.9982 4.07895 11.9982 4.87313V4.87313Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
  </svg>
);
